module.exports = __webpack_public_path__ + "static/img/fill@2x.2a5e6b1c.png";